import { Heading, Link, TextStyle } from '@superops/ui-design-system';
import { BackgroundIcon, Loader } from '@nile/components';
import { SVGIcon } from '@superops/super-icons';
import React, { useContext, useRef, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { HomeContext } from '@nile/mangifera/src/Contexts';
import styled from 'styled-components';
import envConfig from '@nile/home/src/Config/env';
import WorklogHoursSection from '@nile/components/src/Containers/NewWorklog/WorklogHoursSection';
import TimerList from './TimerList';

const Wrapper = styled.div`
  .Superops-Card {
    border-radius: 0px !important;
  }
  .close {
    top: 13px;
    right: 15px;
    z-index: 1;
  }
  .mytimers {
    // width: 500px !important;
    height: ${(props) => `${props?.listHeight || 275}px`};
    background: var(--sops-white-to-grey-bg);
    border-radius: 10px;

    .seperator {
      border-bottom: 1px solid #0000001a;
    }
    .timerslist {
      // height: 100%;
      height: calc(100% - 50px);
    }
    .emptyState {
      height: calc(100% - 40px);
    }
    .emptyState-title {
      color: rgba(0, 0, 0, 0.9);
      font-size: 16px;
      font-weight: 600;
    }
    .emptyState-description {
      max-width: 600px;
      font-size: 12px;
      font-weight: 400;
      line-height: 11px; /* 91.667% */
    }
  }
`;

function RunningTimers(props) {
  const {
    tabContext,
    loading,
    runningTimerEntries: allTimers,
    refetch,
    module,
    associateWorkItem,
    handleClose,
    repositionPopup,
    listHeight,
    setFormHeight
  } = props;
  const intl = useIntl();
  let updateTimer = null;
  const homeContext = useContext(HomeContext);
  const refetchEntries = () => {
    refetch();
  };

  if (loading) {
    return (
      <Wrapper className="p20">
        <div className="fx center min-width-500 mytimers">
          <Loader />
        </div>
      </Wrapper>
    );
  }

  const properties = {
    // allowEmptyState: true,
    disableCloseOnSuccess: true,
    hideWorkitem: true,
    noBoxShadow: true,
    highlightRunningTimer: true,
    manualTimerAssociateWorkItem: true
  };

  function openTimeSheetModule() {
    tabContext.current.openTabCb({
      module: 'TIMESHEET'
    });
    if (homeContext.selectedModule === 'settings') {
      homeContext.toggleSettingsOverlay();
    }
    handleClose();
  }

  const runningTimer = allTimers.filter((tmr) => tmr.running)?.[0];

  if (runningTimer) {
    properties.editMode = true;
    properties.associateWorkItem = true;
    properties.hideWorkitem = false;
    // properties.hideCancel = true;
  }

  return (
    <Wrapper
      id="globaltimerPopup"
      listHeight={listHeight}
      className="position-relative"
    >
      {/* <div onClick={handleClose} className="close position-absolute ptr">
        <SVGIcon name="Close" size="sm" />
      </div> */}
      <div
        id="FormContainer"
        onClick={setFormHeight}
        key={runningTimer?.timerId}
      >
        <WorklogHoursSection
          {...properties}
          globaltimerSection
          timer={runningTimer}
          workItem={runningTimer?.workItem}
          module={runningTimer?.module}
          refetch={refetchEntries}
          handleClose={handleClose}
          handleParentClose={handleClose}
          onTabChange={() => {
            if (updateTimer) clearTimeout(updateTimer);
            updateTimer = setTimeout(() => {
              repositionPopup();
            }, 2000);
          }}
          repositionPopup={repositionPopup}
          // adjustDeleteButton={{ right: '40px', top: '13px' }}
        />
      </div>
      <div className="mytimers min-width-500">
        <div className="seperator mb10 ml-5 mr-5" />
        <div className="mb10 fw fx actr pr-20 pl20">
          <Heading element="h5">
            <FormattedMessage id="running.timers.list.pausedtimers.title" />
            {/* <FormattedMessage id="running.timers.list.mytimers.title" /> */}
            {/* {`(${allTimers.filter((tmr) => !tmr.running)?.length})`} */}
          </Heading>
          <span onClick={openTimeSheetModule} className="ptr mlauto">
            <Link>
              <FormattedMessage id="running.timers.list.view.timesheet.link" />
            </Link>
          </span>
        </div>
        {!allTimers.filter((tmr) => !tmr.running)?.length ? (
          <div className="emptyState flex col center jcenter ignoreOverride">
            <BackgroundIcon
              url={`url(${envConfig.imageRoot}svg/Notimers.svg)`}
              height="100px"
              width="150px"
            />
            {/* <div className="emptyState-title text-align-centr">
              <TextStyle variation="strong">
                <FormattedMessage id="app.globalTimers.noTimers" />
              </TextStyle>
            </div>
            <div className="emptyState-description pt10 text-align-centr">
              <TextStyle variation="subdued">
                <FormattedMessage id="app.globalTimers.noTimers.description" />
              </TextStyle>
            </div> */}
          </div>
        ) : (
          ''
        )}
        <div className="timerslist scroll">
          {allTimers
            .filter((tmr) => !tmr.running)
            .map((timer) => (
              <TimerList
                intl={intl}
                timer={timer}
                tabContext={tabContext}
                handleParentClose={handleClose}
                refetchEntries={refetchEntries}
                associateWorkItem={associateWorkItem}
                editWorklogZIndex={510}
              />
            ))}
        </div>
      </div>
    </Wrapper>
  );
}

export default RunningTimers;
